import 'custom-event-polyfill'

import _ from 'lodash'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store, { showAlert } from './store'
import '@/modal'

import { i18n } from './i18n'

import '@woc/woc-ui'
import './directives'
import './filters'
import './components'

import '@/styles/main.scss'
import 'mapbox-gl/dist/mapbox-gl.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'

import { registerErrorCallback } from '@woc/woc-repository'
import { getEnvironment, BrandEnum } from '@/model/environment'

Vue.config.productionTip = false

if (getEnvironment().id === BrandEnum.values.WOLF.id) {
  import(/* webpackChunkName: "imonitor-theme" */'../node_modules/@woc/woc-ui/dist/wolf-oil-ui-theme/imonitor/wolf-oil-ui-theme.css')
} else {
  import(/* webpackChunkName: "copilot-theme" */'../node_modules/@woc/woc-ui/dist/wolf-oil-ui-theme/copilot/wolf-oil-ui-theme.css')
}

registerErrorCallback(error => {
  const silent = error.config && error.config.silent
  if (!silent) {
    const message = _.get(error, 'response.data.message')
    const alert = {
      label: message,
      labelKey: !message && 'error.general',
      error: true
    }
    showAlert(store, alert)
  }
})

new Vue({
  store,
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
